module.exports = __webpack_public_path__ + "img/character-female.2b872b3d.jpg";